import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User,User2 } from '../models/auth.models';
import { ApiserviceService } from './apiservice.service';

@Injectable({ providedIn: 'root' })
export class AuthfakeauthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    private currentUserSubject2: BehaviorSubject<User2>;
    public currentUser2: Observable<User2>;
    constructor(private http: HttpClient,private api:ApiserviceService) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
         this.currentUserSubject2 = new BehaviorSubject<User2>(JSON.parse(sessionStorage.getItem('kurum_sec')));
        this.currentUser2 = this.currentUserSubject2.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(tcno: string, password: string) {
        return this.api.post('user/giris', { tcno, password })
            .then(user => {
                console.log(user)
                // login successful if there's a jwt token in the response
                if (user && user.data.length) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    sessionStorage.setItem('currentUser', JSON.stringify(user));
                    this.currentUserSubject.next(user);
                    this.acilisyetkili();
                }
                return user;
            });
    }

 
    logout() {
        // remove user from local storage to log user out
        sessionStorage.removeItem('currentUser');
        sessionStorage.removeItem('kurum_sec');
        this.currentUserSubject.next(null);
    }
      acilisyetkili(){
        
        const kullanici={
            perid:JSON.parse(sessionStorage.getItem('currentUser')).data[0].id
          }
         return this.api.post('yetkili/acilisyetki',kullanici)
            .then(user2 => {
                // login successful if there's a jwt token in the response
                if (user2 && user2.data.length) {
                   

                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    sessionStorage.setItem('kurum_sec', JSON.stringify(user2));
                    this.currentUserSubject2.next(user2);
                    console.log(user2)
                }
                return user2;
            });
   
    
    
    }
   
}
